import Vue from 'vue'
import VueResource from 'vue-resource'
import router from '@/router/index'
import globalMixin from '@/mixins'
Vue.use(VueResource)
delete Vue.http.headers.common['X-Requested-With']
import { apiUrl } from "@/config"

// const api = process.env.BASE_URL;
// let api = "http://192.168.10.165/myproject/web_utility/public/api/"
// let api = "http://Utility.doodleblue.tk/api/"
let api = apiUrl
let that = globalMixin.methods
const publicAuthEndpoints = ['login', 'forgot-password', 'reset-password']

Vue.http.interceptors.push(function (request, next) {

  // Start loading screen
  document.getElementById('loadingWrapper').style.display = 'flex';

  // console.log('interceptors----')
  Vue.http.headers.common['content-type'] = 'application/json'
  const requestPath = request.url.replace(api, '')
  const isPublicAuthRequest = publicAuthEndpoints.some(endpoint => requestPath.startsWith(endpoint))
  const token = localStorage.getItem('token')

  if (isPublicAuthRequest || !token) {
    delete Vue.http.headers.common['Authorization']
  } else {
    Vue.http.headers.common['Authorization'] = token
  }

  next(function (response) {
    document.getElementById('loadingWrapper').style.display = 'none';

    if (response.status === 401) {
      that.ERROR_TOAST_MSG(response.body.message);
      localStorage.clear()
      router.push({
        name: 'adminLogin'
      })
    }
    if (response.status === 422 || response.status === 400) {
      that.ERROR_TOAST_MSG(response.body.message);
    }
    if (response.status === 0) {
      localStorage.clear()
      router.push({
        name: 'adminLogin'
      })
      that.ERROR_TOAST_MSG('Network problem')
    }
    if (response.status === 500) {
      console.log(response.body.message, "=====response=====")
      if (response.body.message == 'Token has expired') {
        that.ERROR_TOAST_MSG('Session has expired, please login and continue')
        localStorage.clear()
        router.push({
          name: 'adminLogin'
        })
      } else {
        that.ERROR_TOAST_MSG('Network problem')
      }
    }
  })
})

const get = (resource, slug) => {
  return Vue.http
    .get(`${api}${resource}`, {params: slug})
    .then((response) => Promise.resolve(response.body))
    .catch((error) => Promise.reject(error.body))
}

const post = (resource, body) => {
  return Vue.http.post(`${api}${resource}`, body)
    .then((response) => Promise.resolve(response.body))
    .catch((error) => Promise.reject(error.body))
}

const put = (resource, body) => {
  return Vue.http.put(`${api}${resource}`, body)
    .then((response) => Promise.resolve(response.body))
    .catch((error) => Promise.reject(error.body))
}

const patch = (resource, body) => {
  return Vue.http.patch(`${api}${resource}`, body)
    .then((response) => Promise.resolve(response.body))
    .catch((error) => Promise.reject(error.body))
}

const del = (resource, body) => {
  return Vue.http.delete(`${api}${resource}`, {body: body})
    .then((response) => Promise.resolve(response.body))
    .catch((error) => Promise.reject(error.body))
}

const multipart = (resource, body) => {
  return Vue.http.post(`${api}${resource}`, body, {
    headers: {
      'content-type': 'multipart/form-data' }
  })
  .then((response) => Promise.resolve(response.body))
  .catch((error) => Promise.reject(error.body))
}

export default {
  get,
  post,
  put,
  patch,
  del,
  multipart
}



// WEBPACK FOOTER //
// ./src/services/methods/index.js